const ViewModes = {
  chartView: "chart_view",
  tableView: "table_view",
  insights: "insights",
};

export default ViewModes;
